module.exports = __webpack_public_path__ + "static/media/report_issue.60596a7d.svg";